module.exports = __webpack_public_path__ + "img/6ffeec9538443d32e4a9c4cb2f9c31d3.jpg";